// Dependency-free so both axios.ts and internet.ts can import it without
// creating a cycle (axios.ts imports internet.ts for `connection`).
export function getApiEndpoint() {
    return localStorage.apiEndpoint || import.meta.env.VITE_APP_BASE_URL;
}
